const BadgesModel = {};

BadgesModel.POPULAR = {
  id: 1,
  title: 'Popular',
  label: 'Popular this week',
  active: true,
};

BadgesModel.HOT = {
  id: 2,
  title: 'Hot',
  label: 'Hot new offers',
  active: true,
};

BadgesModel.PRODUCT_OF_THE_DAY = {
  id: 3,
  title: 'Product of the day',
  label: 'Product of the day',
  active: true,
};

BadgesModel.HOTSALES = {
  id: 4,
  title: 'Hot sales',
  label: 'Hot sales',
  active: false,
};

BadgesModel.HOTSALES_ALL_GAMES = {
  id: 5,
  title: 'Hot sales all games',
  label: 'Hot sales all games',
  active: false,
};

BadgesModel.LANDINGS_HOT_OFFERS = {
  id: 6,
  title: 'Landings Hot Offers',
  label: 'Landings Hot Offers',
  active: false,
};

BadgesModel.LIST = [
  BadgesModel.HOT,
  BadgesModel.POPULAR,
  BadgesModel.PRODUCT_OF_THE_DAY,
];

BadgesModel.ID_TO_DATA = {
  [BadgesModel.HOT.id]: BadgesModel.HOT,
  [BadgesModel.POPULAR.id]: BadgesModel.POPULAR,
  [BadgesModel.PRODUCT_OF_THE_DAY.id]: BadgesModel.PRODUCT_OF_THE_DAY,
};

BadgesModel.LIST_ACTIVE = BadgesModel.LIST.filter((badge) => badge.active);

export default BadgesModel;
